(() => {
  const bindPanel = (panel) => {
    if (!panel || panel.dataset.conversionFixesBound === 'true') return;
    panel.dataset.conversionFixesBound = 'true';
    const stickyAction = panel.querySelector('[data-sticky-action]');
    const selectionSummary = panel.querySelector('[data-selection-summary]');
    const stickySelection = panel.querySelector('[data-sticky-selection]');
    const variantInput = panel.querySelector('[data-variant-input]');
    const variantScript = panel.querySelector('[data-product-variants]');
    const price = panel.querySelector('[data-variant-price]');
    const comparePrice = panel.querySelector('[data-variant-compare-price]');
    const discountBadge = panel.querySelector('[data-variant-discount-badge]');
    const saveLine = panel.querySelector('[data-variant-save-line]');
    const fixedValues = String(panel.dataset.fixedOptionValues || '')
      .split('||')
      .map((value) => value.trim())
      .filter(Boolean);
    let variants = [];

    try {
      variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
    } catch (_error) {
      variants = [];
    }

    const cleanSelection = (value) => {
      const source = String(value || '').trim();
      if (!source || !fixedValues.length) return source;
      const parts = source.split(/\s*(?:·|\/)\s*/).map((part) => part.trim()).filter(Boolean);
      const filtered = parts.filter((part) => !fixedValues.includes(part));
      return filtered.length ? filtered.join(' · ') : source;
    };

    const syncSalePrice = () => {
      if (!variantInput || !variants.length) return;
      const variant = variants.find((item) => String(item.id) === String(variantInput.value));
      const hasSale = Boolean(variant && Number(variant.discountPercent) > 0 && variant.compareAtPrice);
      if (price) price.classList.toggle('customiser-price--sale', hasSale);
      if (comparePrice) {
        comparePrice.hidden = !hasSale;
        comparePrice.textContent = hasSale ? variant.compareAtPrice : '';
      }
      if (discountBadge) {
        discountBadge.hidden = !hasSale;
        discountBadge.textContent = hasSale ? `${Math.round(Number(variant.discountPercent))}% OFF` : '';
      }
      if (saveLine) {
        saveLine.hidden = !hasSale;
        saveLine.textContent = hasSale && variant.saveAmount ? `Save ${variant.saveAmount}` : '';
      }
    };

    const sync = () => {
      if (stickyAction && stickyAction.textContent.trim() === 'Choose photo') stickyAction.textContent = 'Add to bag';
      [selectionSummary, stickySelection].forEach((node) => {
        if (!node) return;
        const clean = cleanSelection(node.textContent);
        if (clean && clean !== node.textContent.trim()) node.textContent = clean;
      });
      syncSalePrice();
    };

    sync();
    const observer = new MutationObserver(sync);
    [stickyAction, selectionSummary, stickySelection, price].forEach((node) => {
      if (node) observer.observe(node, { childList: true, subtree: true, characterData: true });
    });
    panel.addEventListener('click', () => window.requestAnimationFrame(sync));
    panel.addEventListener('change', () => window.requestAnimationFrame(sync));
  };

  const bind = () => document.querySelectorAll('[data-product-panel]').forEach(bindPanel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
